import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaArrowDown,
} from "react-icons/fa";
import { motion } from "framer-motion";
import ReactMarkdown from "react-markdown";
import Round from "../../Round.svg";
import CustomFooterMobile from "../../components/CustomFooter-mobile";

const SAMLogoMobile = ({ textes}) => {

  return (
    <section
      id="contact"
      className="flex flex-col h-[100vh] items-center justify-center relative bg-black"
    >
      <div className="flex flex-row text-center top-[20%] w-screen max-w-[80rem] min-h-[100vh] whitespace-nowrap relative pb-[50vh] ">
       <div className="flex items-center justify-center w-full">
          <motion.img
            src={Round}
            alt="SAM Logo"
            className=""
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 6 }}
            exit={{ opacity: 0 }}
            width={"50%"}
            height={"50%"}
          />
        </div>
        <div className="text-center items-center justify-center w-full absolute top-0 left-0">
          <span
            className="font-sam text-[6rem] text-white mx-4 relative"
            style={{
              fontFamily: "SAM",
              color: "white",
              fontSize: "14rem",
              top: "10rem",
            }}
          >
            {textes?.samLogoS || "S"}
            {textes?.samLogoA || "A"}
            {textes?.samLogoM || "M"}
          </span>
        </div>
        <span
          className="absolute text-white text-4xl text-center mt-10"
          style={{
            fontFamily: "Lexend",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <ReactMarkdown
            className="text-white text-4xl text-center"
            escapeHtml={false}
            components={{
              strong: ({ node, ...props }) => (
                <span className="text-[#00ffcc] font-sam font-[200]" {...props} />
              ),
            }}
          >
            {textes?.stayConnected.replace("\n", `\n`)}
          </ReactMarkdown>
        </span>
        <a
          className="absolute border-[#00FFCC] border-2 rounded-full p-5"
          href={"mailto:" + textes?.contactEmail.replace(/\*\*/g, "")}
          style={{
            fontFamily: "Lexend",
            top: "60%",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <ReactMarkdown
            className="text-white text-3xl"
            escapeHtml={false}
            style={{
              fontFamily: "Lexend !important",
            }}
            components={{
              strong: ({ node, ...props }) => (
                <span className="text-strong" {...props} />
              ),
            }}
          >
            {textes?.contactEmail}
          </ReactMarkdown>
        </a>
      </div>
    </section>
  );
};

export default SAMLogoMobile;
